import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiService } from "../services/base-api.service";
import { HelpersService } from "../services/helpers.service";
import { ProgressService } from "../services/progress.service";
import { LoadingService } from "../services/loading.service";
import { share } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class NotificationService extends BaseApiService<any> {
  constructor(
    public override http: HttpClient,
    public override helper: HelpersService,
    public override loading: ProgressService,
    public override loadingService: LoadingService,
  ) {
    super(http, helper, loading, loadingService);
    this.endpoint = 'notification';
    this.query = { limit: 0, page: 0 };
  }
  
  readNotification(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_array(['read', id]);
      this.loadingService.startLoading()
      this.http
        .get<any>(url)
        .pipe(share())
        .subscribe({
          next: ({ data }) => {
            this.loadingService.endLoading()
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }
  
  readAllNotification(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_array(['read', 'all', id]);
      this.loadingService.startLoading()
      this.http
        .get<any>(url)
        .pipe(share())
        .subscribe({
          next: ({ data }) => {
            this.loadingService.endLoading()
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }
}
